
import { BaseVue } from "@newview/base-web";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
//import { FlowTaskApi } from "@newview/dynamiclaboratory-api";
import { WorkFlowTaskApi} from "@newview/basicdata-api";

@Component({
  components: {},
})
export default class FlowStepRecord extends BaseVue {
  //#region 接口定义区
  flowTaskApi: WorkFlowTaskApi = new WorkFlowTaskApi();
  @Prop({ default: ()=>({}) }) itemInfo!: any;
  stepsList: any = [];
  activeStepObj: any = {};

  mounted() {
    // 获取流程步骤记录
    this.getStepDetails();
  }

  /**
   * 获取流程步骤记录
   */
  async getStepDetails() {
    //查询流程步骤；
    let res = await this.flowTaskApi.getStepRecord(
      this.itemInfo.flowId,
      this.itemInfo.biid
    );
    if (res.code == 200) {
      this.stepsList = res.data;
      // if(res.data[0].reviewStatus == 8 || res.data[0].reviewStatus == 9){
      //   this.activeStepObj.NowStepNum = res.data.length;
      // }else {
         res.data.map((e, index) => {
          if (e.status == 2) this.activeStepObj.NowStepNum = index;
       });
      //}
    }
  }

  async getStep(itemInfo) {
    //查询流程步骤；
      let res = await this.flowTaskApi.getStepRecord(
      this.itemInfo.flowId,
      this.itemInfo.biid
    );
    if (res.code == 200) {
      this.stepsList = res.data;
      // if(res.data[0].reviewStatus == 8 || res.data[0].reviewStatus == 9){
      //   this.activeStepObj.NowStepNum = res.data.length;
      // }else {
         res.data.map((e, index) => {
          if (e.status == 2) this.activeStepObj.NowStepNum = index;
       });
      //}
    }
  }

  //#endregion 方法定义区
}
